import React from 'react';
import PropTypes from 'prop-types';

import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import LinearProgress from '@material-ui/core/LinearProgress';
import Divider from '@material-ui/core/Divider';

import AddCircleIcon from '@material-ui/icons/AddCircle';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import EditIcon from '@material-ui/icons/Edit';

import DataTableToolbar from '../../_Shared/DataTables/DataToolbar';
import DataTable from '../../_Shared/DataTables/DataTable';
import AppContent from '../../_Shared/Layout/AppContent';
import ReportEdit from './ReportEdit';

class ReportList extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            anchorEl: null, report: null, reportEdit: false
        }
    }

    componentDidMount() {
        this.props.onActivate();
    }

    toggleRowMenu = currentTarget => {
        this.setState((prevState) => {
            return { anchorEl: prevState.anchorEl === currentTarget ? null : currentTarget }
        })
    }
    selectElement = report => {
        this.setState({ report });
    }
    closeToggleRowMenu = () => {
        this.setState({ anchorEl: null });
    }
    uploadNewReport = e => {
        this.props.saveHandler(e);
    }
    editReport = e => {
        this.setState({ reportEdit: true, anchorEl: null });
    }
    reportEditClosed = e => {
        this.setState({ reportEdit: false });
    }
    saveReport = report => {

        this.setState({ reportEdit: false }, () =>
            this.props.updateHandler(report));
    }
    deleteReport = e => {
        const { report } = this.state;
        this.props.deleteHandler(report);
    }
    updateReportFile = e => {
        const { report } = this.state;
        this.props.fileUpdateHandler(e, report);
    }
    render() {
        const { reports, loading, reportTypes } = this.props;
        const { anchorEl, report, reportEdit } = this.state;
        return (<AppContent>
            {
                loading && <LinearProgress variant="query" />
            }
            <DataTableToolbar title="Advertiser Reports" numSelected={0} >
                <Tooltip title="Add New">
                    <React.Fragment>
                        <label htmlFor="toolbar_upload">
                            <IconButton color="secondary" component="span"><AddCircleIcon /></IconButton>
                        </label>
                        <input accept=".pbix" id="toolbar_upload" onChange={this.uploadNewReport} style={{ display: 'none' }} type="file" />
                    </React.Fragment>
                </Tooltip>
            </DataTableToolbar>
            {
                reports &&
                <DataTable columns={[{ label: 'Name', field: 'name' }, { label: 'Status', field: 'status', format: (x) => x.toUpperCase(), numeric: true }]}
                    anchorEl={anchorEl} rows={reports} toggleRowMenu={this.toggleRowMenu} onElementSelect={this.selectElement}
                    onCloseToggleRowMenu={this.closeToggleRowMenu}>
                    <MenuItem onClick={this.editReport}>
                        <ListItemIcon><EditIcon /></ListItemIcon>
                        <ListItemText inset primary="Settings" />
                    </MenuItem>
                    <MenuItem component="label">
                        <ListItemIcon><AddCircleIcon /></ListItemIcon>
                        <ListItemText inset primary="Re-upload" />
                        <input accept=".pbix" onChange={this.updateReportFile} style={{ display: 'none' }} type="file" />
                    </MenuItem>
                    <Divider />
                    <MenuItem onClick={this.deleteReport}>
                        <ListItemIcon><DeleteForeverIcon /></ListItemIcon>
                        <ListItemText inset primary="Delete" />
                    </MenuItem>
                </DataTable>
            }
            {
                reportEdit && <ReportEdit report={report} onClose={this.reportEditClosed} reportTypes={reportTypes} onReportSave={this.saveReport} />
            }
        </AppContent>)
    }
}

ReportList.propTypes = {
    reports: PropTypes.array.isRequired,
};


export default ReportList;


// WEBPACK FOOTER //
// ./src/Components/Presentation/Advertisers/Reports/ReportList.js